// @flow
import * as React from "react";
import idx from "idx";
import { connect, type MapStateToProps } from "react-redux";
import { ThemeProvider } from "styled-components";
import * as themes from "../themes";
import {
  newIndex as redesign,
  thProjectTrade,
} from "../themes/irontrade/irontrade";

import type { State } from "../redux/reducer";
import type { Dispatch } from "../redux/action";

let themeTarget = (() => {
  switch (process.env.REACT_APP_DEPLOY_TARGET) {
    case "siamoption":
      return "ThProject";
    case "eztrader":
      return "eztrader";
    case "irontrade":
    default:
      return "iron";
  }
})();
// process.env.REACT_APP_DEPLOY_TARGET === "siamoption" ? "ThProject" : "iron";

const mapStateToTheme: MapStateToProps<*, *, *> = (state: State) => ({
  theme: state.settings.theme,
  profile: state.profile,
});

type Props = {
  dispatch: Dispatch,
  theme: string,
  children: React.Node,
  themeOverride?: string,
};

const _ThemeProvider = (props: Props) => {
  const themeKey = props.themeOverride || "default";
  const theme = themes[themeKey + themeTarget];
  const defaultTheme = themes["default" + themeTarget];

  return (
    <ThemeProvider theme={theme || defaultTheme}>
      {props.children}
    </ThemeProvider>
  );
};

export default connect(mapStateToTheme)(_ThemeProvider);

export const TradeThemeContext = React.createContext(null);

export const TradeThemeContextProvider = connect(mapStateToTheme)(
  (props: Props) => {
    const themeKey = props.theme + themeTarget;
    const currentTheme =
      props.profile != null &&
      props.profile.currency === "THB" &&
      themeTarget === "iron" &&
      props.theme === "default"
        ? themes.thProjectTrade
        : themes[themeKey];

    const defaultThemeKey =
      process.env.REACT_APP_DEPLOY_TARGET === "irontrade" ? "light" : "default";
    const defaultTheme = themes[defaultThemeKey + themeTarget];

    React.useEffect(() => {
      // если темы нет, сбрасываем settings.theme на дефолтную
      // светлую для irontrade, темную — для всего остального
      if (currentTheme == null || props.theme == null) {
        props.dispatch({
          type: "UPDATE_SETTINGS",
          payload: {
            theme: defaultThemeKey,
          },
        });
      }
    }, [props.theme]);

    return (
      <TradeThemeContext.Provider value={currentTheme || defaultTheme}>
        {props.children}
      </TradeThemeContext.Provider>
    );
  }
);

export const TradeThemeProvider = (props: { children: React.Node }) => {
  const theme = React.useContext(TradeThemeContext);

  return <ThemeProvider theme={theme}>{props.children}</ThemeProvider>;
};

type ThemeProps = {
  children: React.Node,
  isMobileApp: boolean,
  isInnerHeader?: boolean,
};

const _IronRedesignThemeProvider = ({
  children,
  isMobileApp,
  isInnerHeader,
  theme,
}: ThemeProps) =>
  process.env.REACT_APP_DEPLOY_TARGET === "irontrade" ? (
    <ThemeProvider
      theme={
        isMobileApp || window.isApp
          ? {}
          : theme === "thProjectTrade"
          ? thProjectTrade
          : isInnerHeader
          ? {}
          : redesign
      }
    >
      {children}
    </ThemeProvider>
  ) : children != null ? (
    children
  ) : null;

window.isApp = /wvbo/g.test(window.navigator.userAgent);
window.isFullAndroidApp = /wvbo_full/g.test(window.navigator.userAgent);

const mapStateToMobileApp: MapStateToProps<*, *, *> = (state: State) => {
  const isIOS = idx(state, (state) => state.serverData.isIOS);
  const isAndroidApp = idx(state, (state) => state.serverData.isAndroidApp);

  return {
    isMobileApp: isIOS || isAndroidApp || window.isApp,
  };
};

export const IronRedesignThemeProvider = connect(mapStateToMobileApp)(
  _IronRedesignThemeProvider
);



// WEBPACK FOOTER //
// ./src/components/ThemeProvider.js